var _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHerotext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 506,
    height: 514,
    viewBox: "0 0 506 514",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_n_39_526)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_39_526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.705 16.699L342.097 128.899L322.561 160.051L315.169 47.851L334.705 16.699Z",
    fill: "#673333"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_39_526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.296 100.387C275.864 106.987 271.112 112.795 265.568 117.283C259.76 122.035 252.632 126.523 244.184 131.011C238.64 133.915 232.304 136.291 225.44 138.139C218.312 139.987 211.448 142.099 204.848 143.683C197.984 145.795 191.648 148.171 185.84 151.339C182.408 153.187 179.24 155.299 176.072 158.467C172.904 161.107 171.848 165.595 172.64 171.139L183.728 240.043C184.784 248.755 185.048 257.731 184.256 267.235C183.464 276.739 182.144 285.187 180.032 292.579C178.448 280.171 176.336 268.291 173.696 256.675C171.056 244.795 168.68 233.179 166.832 221.299C164.72 209.419 163.664 197.275 163.4 184.339C163.4 174.571 164.456 165.331 166.304 156.355C168.152 147.115 170.792 138.931 174.224 131.539C178.712 124.675 184.784 119.659 192.44 116.227C200.096 113.059 208.544 110.155 218.312 107.515L236.792 102.763C240.224 95.107 243.128 89.299 244.976 85.075C246.824 80.851 248.408 77.683 249.728 75.571C251.048 73.459 252.104 71.875 252.896 70.819C253.688 69.763 254.744 68.707 256.064 67.651C258.968 65.011 263.192 63.955 268.472 64.483C273.752 64.747 278.768 65.275 283.52 65.803C285.896 66.067 287.48 67.123 287.744 68.971C288.272 70.819 288.272 72.667 288.008 74.515C285.896 84.811 282.992 93.523 279.296 100.387Z",
    fill: "#673333"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_n_39_526)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_39_526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.295 10.4L344.135 129.414L320.971 166.35L313.13 47.3365L336.295 10.4ZM315.17 47.8512L322.561 160.051L342.097 128.899L334.705 16.6989L315.17 47.8512Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_39_526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.765 66.1295C258.218 63.0201 263.052 61.9372 268.635 62.4889C273.957 62.7572 279.004 63.2887 283.741 63.8151C285.147 63.9713 286.505 64.3792 287.6 65.1754C288.706 65.9798 289.46 67.1277 289.7 68.5446C290.292 70.6988 290.273 72.8034 289.988 74.7975L289.979 74.858L289.967 74.9166C287.833 85.3221 284.88 94.2254 281.07 101.309C277.513 108.149 272.587 114.173 266.826 118.837C260.883 123.698 253.635 128.255 245.123 132.777L245.112 132.783C239.414 135.767 232.936 138.192 225.96 140.07L225.951 140.073L225.942 140.075C219.003 141.874 211.939 144.034 205.382 145.611C198.605 147.699 192.427 150.024 186.797 153.094L186.789 153.1C183.479 154.882 180.482 156.886 177.486 159.881L177.422 159.945L177.352 160.004C174.957 162 173.878 165.614 174.615 170.821L185.703 239.725L185.709 239.763L185.713 239.802L185.905 241.463C186.814 249.782 187.002 258.356 186.249 267.401C185.45 276.982 184.115 285.569 181.955 293.129L178.048 292.833C176.473 280.488 174.371 268.67 171.746 257.118L171.744 257.109C169.103 245.224 166.719 233.574 164.863 221.649C162.863 210.399 161.803 198.93 161.46 186.812L161.4 184.38V184.339L161.413 182.486C161.537 173.257 162.588 164.487 164.342 155.963C166.218 146.584 168.904 138.247 172.41 130.697L172.471 130.566L172.55 130.445C177.262 123.238 183.641 117.979 191.622 114.402L191.648 114.39L191.675 114.379C199.415 111.176 207.945 108.246 217.791 105.585L217.802 105.581L217.814 105.578L235.366 101.064C236.938 97.58 238.39 94.4904 239.67 91.7789C241.061 88.8303 242.234 86.3526 243.144 84.2731C245.004 80.0217 246.634 76.7481 248.032 74.5114C249.361 72.3854 250.453 70.7436 251.296 69.6188C252.203 68.4108 253.37 67.2505 254.765 66.1295ZM268.472 64.483C263.192 63.955 258.968 65.011 256.064 67.651C254.744 68.707 253.688 69.763 252.896 70.819L252.587 71.2399C251.836 72.2793 250.883 73.7231 249.728 75.5709L249.22 76.4127C248.008 78.4917 246.593 81.3791 244.976 85.0748L244.235 86.734C242.394 90.7801 239.795 96.0643 236.792 102.763L218.312 107.515C208.544 110.155 200.096 113.059 192.44 116.227C184.784 119.659 178.712 124.675 174.224 131.539C170.792 138.931 168.152 147.115 166.304 156.355C164.456 165.331 163.4 174.571 163.4 184.339C163.664 197.275 164.72 209.42 166.832 221.299C168.68 233.179 171.056 244.796 173.696 256.675C176.336 268.291 178.448 280.171 180.032 292.579C182.012 285.649 183.296 277.791 184.101 269.005L184.256 267.235C185.048 257.731 184.784 248.755 183.728 240.043L172.64 171.139C171.848 165.595 172.904 161.107 176.072 158.467C179.042 155.497 182.012 153.455 185.2 151.689L185.84 151.339C191.285 148.37 197.194 146.095 203.567 144.083L204.848 143.683C211.448 142.099 218.312 139.987 225.44 138.139C232.304 136.291 238.64 133.915 244.184 131.011C252.632 126.523 259.76 122.035 265.568 117.283C270.939 112.935 275.566 107.349 278.97 101.004L279.296 100.387C282.992 93.5234 285.896 84.8112 288.008 74.5153C288.272 72.6673 288.272 70.8192 287.744 68.9713C287.496 67.2387 286.089 66.2022 283.956 65.8619L283.52 65.8033C278.768 65.2754 273.752 64.7471 268.472 64.483Z",
    fill: "white"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_n_39_526)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_39_526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.182 229.107C305.75 234.123 302.318 238.875 298.886 243.363C298.358 244.155 297.83 244.419 297.302 244.683C296.51 244.947 295.718 243.891 294.926 242.043C292.286 235.443 289.382 231.483 286.214 229.635C283.31 227.787 280.142 227.787 277.238 229.371C274.07 230.955 270.902 233.595 267.734 237.027C264.83 240.459 261.926 244.419 259.286 248.643C256.646 252.867 254.27 256.827 252.422 260.259C250.31 263.691 248.726 266.331 247.67 267.915L247.406 256.299L247.67 256.035C250.046 251.547 253.478 245.475 257.966 237.819C262.454 230.163 267.47 222.507 273.014 215.115C276.71 210.099 280.406 205.875 284.366 202.443C288.326 198.747 292.286 196.635 296.246 195.843C300.47 195.051 304.694 196.899 308.918 200.859C310.766 202.707 312.614 204.555 314.198 206.667C315.518 208.779 316.838 211.155 318.158 213.531C315.518 219.075 312.614 224.091 309.182 229.107Z",
    fill: "#673333"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_39_526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.643 246.242C356.559 244.91 357.571 243.428 358.674 241.851C360.258 239.211 362.106 236.571 364.482 233.667C366.858 230.235 370.026 226.803 373.458 223.107C377.154 219.147 381.114 215.979 385.602 213.603C390.09 210.963 394.578 209.643 399.33 209.907C404.082 209.907 408.57 212.283 413.058 216.771C420.714 224.691 424.674 233.667 424.674 243.963C424.674 253.731 422.561 263.235 418.337 272.475C410.418 289.635 401.178 302.043 390.618 309.699C385.074 313.659 378.474 317.091 370.554 319.731C362.634 322.899 353.922 324.747 344.682 325.803C343.626 325.803 342.834 325.803 342.306 326.067C341.516 326.067 340.916 325.876 340.561 325.498L340.175 326.067L337.536 293.067C328.296 306.795 319.319 314.715 310.343 317.091C305.855 318.411 300.84 319.731 295.032 321.051C289.588 322.235 283.719 323.84 277.236 325.492C277.162 325.571 277.09 325.652 277.015 325.731H276.752C276.519 325.809 276.333 325.816 276.191 325.757C275.785 325.859 275.378 325.964 274.967 326.067L275.754 321.456C271.849 323.212 266.726 324.726 260.383 325.995C253.783 327.315 247.184 328.635 240.584 329.691C239.396 329.874 238.232 330.047 237.093 330.214C236.73 331.493 236.33 332.778 235.889 334.067C232.721 344.099 227.969 353.603 221.105 362.579C214.769 371.555 206.849 379.211 198.401 385.811C189.425 392.147 180.449 396.107 170.945 397.955C161.177 399.803 151.409 400.331 141.378 400.067C131.082 399.539 121.313 398.747 111.546 397.955C110.754 397.691 110.225 397.163 110.225 396.371C110.225 395.315 110.489 394.524 111.281 394.259C125.009 386.603 139.529 379.739 155.105 373.931C170.681 368.123 185.994 362.051 201.042 355.979C205.001 354.395 208.698 352.283 212.129 349.907C215.561 347.531 218.465 344.627 221.105 341.723C221.897 340.931 222.161 339.347 221.633 337.235C220.841 334.859 220.049 333.275 219.257 331.955C215.034 332.747 210.545 333.011 205.794 332.483C200.778 332.219 197.345 330.635 194.969 328.259C193.121 325.884 192.066 323.507 192.33 320.34C192.594 317.7 193.121 314.795 194.441 312.155C197.345 306.347 200.25 300.539 202.626 294.467C205.266 288.395 208.697 283.115 212.921 278.363C214.769 275.987 217.409 275.459 220.577 276.515C223.481 277.571 225.857 278.891 227.441 280.475C232.421 285.455 235.871 291.13 237.794 297.499C237.843 297.493 237.893 297.489 237.943 297.483C243.223 296.955 248.767 296.163 255.103 295.371C261.439 294.579 267.512 293.523 273.32 292.467C279.392 291.147 284.144 289.827 287.576 288.243C291.008 286.923 293.647 284.811 296.023 281.907C298.135 279.267 299.719 276.891 300.511 274.515C301.303 273.195 301.568 273.195 301.832 275.043C302.096 276.627 301.831 277.683 301.567 277.947C300.49 281.178 299.234 285.111 297.663 289.461C316.923 286.251 329.819 282.878 336.479 279.34L330.671 198.819L350.208 166.611L355.643 246.242ZM386.129 249.507C375.007 243.328 365.042 246.174 356.45 258.046L358.771 292.059C366.659 291.251 374.086 289.984 380.85 288.051C388.77 286.467 395.898 283.827 402.762 280.659C403.554 266.403 398.009 256.107 386.129 249.507ZM486.45 128.331C488.826 127.011 489.618 127.539 489.354 130.179L480.642 161.067C471.138 166.611 462.162 171.891 453.186 176.643C444.738 181.659 436.026 186.411 427.314 191.427C418.602 196.443 409.626 201.723 399.858 207.267C397.482 208.587 396.426 208.059 396.954 205.419L405.666 174.795C415.434 169.251 424.41 163.971 433.122 158.955C441.834 153.939 450.282 149.187 458.994 144.171C467.706 139.155 476.682 133.875 486.45 128.331Z",
    fill: "#673333"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_39_526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.296 302.387C128.864 308.987 124.112 314.795 118.568 319.283C112.76 324.035 105.632 328.523 97.184 333.011C91.64 335.915 85.304 338.291 78.44 340.139C71.312 341.987 64.448 344.099 57.848 345.683C50.984 347.795 44.648 350.171 38.84 353.339C35.408 355.187 32.24 357.299 29.072 360.467C25.904 363.107 24.848 367.595 25.64 373.139L36.728 442.043C37.784 450.755 38.048 459.731 37.256 469.235C36.464 478.739 35.144 487.187 33.032 494.579C31.448 482.171 29.336 470.291 26.696 458.675C24.056 446.795 21.68 435.179 19.832 423.299C17.72 411.419 16.664 399.275 16.4 386.339C16.4 376.571 17.456 367.331 19.304 358.355C21.152 349.115 23.792 340.931 27.224 333.539C31.712 326.675 37.784 321.659 45.44 318.227C53.096 315.059 61.544 312.155 71.312 309.515L89.792 304.763C93.224 297.107 96.128 291.299 97.976 287.075C99.824 282.851 101.408 279.683 102.728 277.571C104.048 275.459 105.104 273.875 105.896 272.819C106.688 271.763 107.744 270.707 109.064 269.651C111.968 267.011 116.192 265.955 121.472 266.483C126.752 266.747 131.768 267.275 136.52 267.803C138.896 268.067 140.48 269.123 140.744 270.971C141.272 272.819 141.272 274.667 141.008 276.515C138.896 286.811 135.992 295.523 132.296 302.387Z",
    fill: "#673333"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_n_39_526)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_39_526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.674 243.963C424.674 233.667 420.714 224.691 413.058 216.771C408.57 212.283 404.082 209.907 399.33 209.907C394.578 209.643 390.09 210.963 385.602 213.603C381.114 215.979 377.154 219.147 373.458 223.107C370.026 226.803 366.858 230.235 364.482 233.667C362.106 236.571 360.258 239.211 358.674 241.851C357.571 243.428 356.559 244.91 355.643 246.242L355.424 243.03C355.918 242.311 356.44 241.556 356.995 240.762C358.612 238.073 360.491 235.392 362.881 232.465C365.349 228.915 368.603 225.396 371.993 221.746L371.996 221.743C375.806 217.66 379.926 214.353 384.623 211.859C388.016 209.868 391.472 208.555 395.076 208.076C394.976 207.816 394.912 207.556 394.875 207.313C394.762 206.582 394.84 205.791 394.993 205.027L395.008 204.949L395.03 204.872L403.966 173.46L404.678 173.055C414.442 167.514 423.388 162.251 432.124 157.221C436.485 154.71 440.78 152.266 445.069 149.825C449.359 147.383 453.645 144.943 457.996 142.438C466.684 137.436 475.691 132.138 485.462 126.591L485.47 126.588L485.479 126.583C486.136 126.218 486.818 125.902 487.486 125.745C488.141 125.591 489.093 125.522 489.973 126.088C490.861 126.658 491.188 127.56 491.312 128.226C491.437 128.899 491.418 129.645 491.344 130.378L491.327 130.552L482.347 162.387L481.65 162.795C472.174 168.322 463.169 173.618 454.162 178.388C445.724 183.397 436.944 188.19 428.312 193.16C420.055 197.914 411.509 202.933 402.294 208.18C406.458 208.952 410.332 211.332 414.032 214.923L414.472 215.357L414.496 215.381C422.466 223.626 426.674 233.085 426.674 243.963L426.668 244.906C426.536 254.641 424.36 264.113 420.157 273.306L420.154 273.313C412.151 290.654 402.726 303.391 391.792 311.318L391.781 311.327C386.079 315.4 379.314 318.913 371.235 321.611C363.116 324.85 354.239 326.723 344.909 327.79L344.796 327.803H344.682C344.129 327.803 343.758 327.804 343.462 327.829C343.211 327.85 343.146 327.88 343.173 327.869L342.778 328.067H342.306C341.426 328.067 340.417 327.899 339.579 327.289C338.641 326.607 338.194 325.577 338.194 324.483V324.004L339.763 320.915L340.175 326.067L340.561 325.498C340.879 325.837 341.393 326.026 342.065 326.061L342.306 326.067C342.702 325.869 343.246 325.82 343.939 325.807L344.682 325.803C353.922 324.747 362.634 322.899 370.554 319.731C378.474 317.091 385.074 313.659 390.618 309.699C400.848 302.282 409.839 290.406 417.591 274.07L418.337 272.475C422.43 263.524 424.54 254.325 424.668 244.878L424.674 243.963ZM356.45 258.046C365.042 246.174 375.007 243.328 386.129 249.507C398.009 256.107 403.554 266.403 402.762 280.659C395.898 283.827 388.77 286.467 380.85 288.051C374.086 289.984 366.659 291.251 358.771 292.059L358.635 290.062C366.417 289.262 373.699 288.014 380.3 286.128L380.379 286.106L380.458 286.09C387.76 284.629 394.393 282.243 400.815 279.347C401.003 273.031 399.848 267.668 397.434 263.156C394.952 258.516 391.071 254.649 385.684 251.552L385.159 251.256C379.599 248.167 374.588 247.599 369.998 249.215C365.428 250.825 360.946 254.713 356.669 261.256L356.45 258.046ZM489.354 130.179C489.618 127.539 488.826 127.011 486.45 128.331C476.682 133.875 467.706 139.155 458.994 144.171C450.282 149.187 441.834 153.939 433.122 158.955C424.41 163.971 415.434 169.251 405.666 174.795L396.954 205.419C396.426 208.059 397.482 208.587 399.858 207.267C407.184 203.109 414.065 199.1 420.722 195.239L427.314 191.427C436.026 186.411 444.738 181.659 453.186 176.643C462.162 171.891 471.138 166.611 480.642 161.067L489.354 130.179Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_39_526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.175 326.067L340.561 325.498C340.916 325.876 341.516 326.067 342.306 326.067C342.42 326.01 342.546 325.968 342.683 325.933L338.635 331.894L335.982 298.735C327.738 309.871 319.46 316.732 310.893 319.013C306.367 320.344 301.315 321.674 295.474 323.002L295.457 323.005C289.421 324.318 282.925 326.139 275.453 328.007L272.481 328.751L273.57 322.364C274.336 322.069 275.064 321.766 275.754 321.456L274.967 326.067C275.378 325.964 275.785 325.859 276.191 325.756C276.333 325.816 276.519 325.809 276.752 325.731H277.015C277.09 325.652 277.162 325.571 277.236 325.492C283.267 323.955 288.766 322.459 293.886 321.304L295.032 321.051C300.84 319.731 305.855 318.411 310.343 317.091C319.319 314.715 328.296 306.795 337.536 293.067L340.175 326.067ZM360.761 291.844C360.101 291.919 359.438 291.991 358.771 292.059L356.45 258.046C357.057 257.207 357.671 256.413 358.292 255.665L360.761 291.844ZM284.533 289.462C282.867 290.05 280.987 290.608 278.893 291.151L279.05 290.229L280.503 290.03C281.87 289.842 283.213 289.651 284.533 289.462ZM351.773 160.174L357.466 243.589C356.823 244.523 356.214 245.411 355.643 246.242L350.208 166.611L330.671 198.819L336.479 279.339L335.658 279.759C328.787 283.145 316.159 286.378 297.663 289.461C297.927 288.729 298.182 288.01 298.429 287.303C304.99 286.194 310.78 285.067 315.806 283.922C324.199 282.011 330.348 280.073 334.388 278.148L328.63 198.327L351.773 160.174Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_39_526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.3 333.899C220.363 334.031 220.428 334.164 220.491 334.302L220.23 334.331L220.3 333.899ZM274.967 326.067C275.378 325.964 275.785 325.859 276.191 325.756C276.333 325.816 276.519 325.809 276.752 325.731H277.015L277.236 325.492C278.418 325.191 279.581 324.892 280.723 324.596C279.994 325.446 279.244 326.284 278.469 327.104L277.878 327.731H277.004C276.659 327.804 276.231 327.835 275.771 327.72C275.021 327.533 274.473 327.031 274.171 326.427C273.909 325.905 273.86 325.372 273.86 324.989C273.86 324.788 273.874 324.583 273.898 324.379C270.259 325.747 265.876 326.937 260.776 327.957C254.183 329.275 247.544 330.602 240.899 331.666L240.887 331.668C239.373 331.901 237.896 332.119 236.46 332.327C236.682 331.621 236.894 330.916 237.093 330.213C237.409 330.167 237.728 330.122 238.047 330.075L240.584 329.691C247.184 328.635 253.783 327.315 260.383 325.995C266.726 324.726 271.849 323.212 275.754 321.456L274.967 326.067ZM300.252 271.858C300.636 271.649 301.274 271.452 302.002 271.694C302.666 271.915 303.031 272.384 303.198 272.649C303.373 272.926 303.474 273.205 303.536 273.403C303.656 273.79 303.737 274.252 303.804 274.714C303.965 275.678 303.975 276.539 303.879 277.254C303.832 277.61 303.755 277.959 303.639 278.28C303.584 278.433 303.501 278.633 303.377 278.844C302.416 281.735 301.295 285.227 299.927 289.077C299.182 289.205 298.428 289.333 297.663 289.461C299.234 285.111 300.49 281.178 301.567 277.947C301.831 277.683 302.096 276.627 301.832 275.043C301.568 273.195 301.303 273.195 300.511 274.515C299.719 276.891 298.135 279.267 296.023 281.907C293.647 284.811 291.008 286.923 287.576 288.243C284.144 289.827 279.392 291.147 273.32 292.467C267.512 293.523 261.439 294.579 255.103 295.371C248.767 296.163 243.223 296.955 237.943 297.483C237.893 297.489 237.843 297.493 237.794 297.499C237.596 296.844 237.382 296.197 237.152 295.557C237.34 295.537 237.53 295.517 237.722 295.496L237.734 295.494L237.745 295.493C242.993 294.968 248.471 294.184 254.855 293.386C261.114 292.604 267.123 291.56 272.908 290.508C278.952 289.194 283.518 287.913 286.737 286.427L286.796 286.4L286.857 286.377C289.904 285.205 292.273 283.331 294.475 280.64C296.546 278.05 297.939 275.906 298.614 273.882L298.683 273.674L298.796 273.486C298.998 273.151 299.246 272.758 299.524 272.447C299.66 272.295 299.903 272.048 300.252 271.858Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_d_39_526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.878 193.878C300.837 192.948 305.538 195.091 309.868 199.014L310.286 199.4L310.309 199.422L310.333 199.445C312.05 201.162 313.871 202.98 315.479 205.049L315.798 205.467L315.849 205.535L315.894 205.607C316.909 207.23 317.919 208.999 318.916 210.78L319.907 212.56L320.407 213.461L319.963 214.391C317.278 220.031 314.321 225.137 310.833 230.236C307.389 235.269 303.943 240.04 300.495 244.55C299.684 245.728 298.797 246.172 298.197 246.472L298.07 246.536L297.934 246.581C296.34 247.112 295.149 246.102 294.595 245.457C293.997 244.758 293.505 243.804 293.087 242.831L293.079 242.808L293.069 242.786C290.563 236.521 287.959 233.089 285.449 231.509L285.207 231.363L285.173 231.343L285.14 231.322C282.881 229.885 280.493 229.873 278.196 231.127L278.165 231.144L278.132 231.16C275.273 232.589 272.306 235.028 269.237 238.346C266.404 241.697 263.565 245.57 260.982 249.703C258.35 253.914 256.001 257.832 254.183 261.208L254.156 261.258L254.126 261.307C252.039 264.698 250.417 267.4 249.335 269.024L245.815 274.303L245.387 255.49L246.047 254.829C248.437 250.332 251.836 244.321 256.241 236.807C260.76 229.098 265.814 221.383 271.404 213.928C275.156 208.836 278.95 204.49 283.056 200.931C287.21 197.069 291.475 194.757 295.854 193.881L295.878 193.878ZM308.919 200.859C304.695 196.899 300.471 195.052 296.247 195.843C292.287 196.635 288.326 198.747 284.366 202.443C280.406 205.875 276.71 210.099 273.014 215.115C267.47 222.507 262.454 230.163 257.966 237.819L256.333 240.616C252.637 246.968 249.749 252.108 247.671 256.035L247.406 256.299L247.671 267.915C248.726 266.331 250.311 263.691 252.422 260.259C254.039 257.256 256.061 253.849 258.309 250.214L259.286 248.643C261.926 244.419 264.83 240.459 267.734 237.027C270.902 233.595 274.07 230.955 277.238 229.371C280.142 227.787 283.31 227.787 286.214 229.635C289.382 231.483 292.286 235.443 294.926 242.043C295.669 243.775 296.411 244.812 297.154 244.717L297.302 244.683C297.83 244.419 298.358 244.155 298.886 243.363C301.889 239.436 304.892 235.307 307.895 230.975L309.182 229.107C312.614 224.091 315.518 219.075 318.158 213.531C316.838 211.155 315.518 208.779 314.198 206.667C312.614 204.555 310.766 202.707 308.919 200.859Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_d_39_526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.259 329.891C238.826 331.493 238.334 333.101 237.782 334.714C234.551 344.93 229.704 354.62 222.712 363.769C216.238 372.93 208.178 380.711 199.632 387.387L199.594 387.417L199.554 387.445C190.377 393.923 181.142 398.01 171.327 399.919L171.317 399.921C161.997 401.684 152.7 402.261 143.222 402.107L141.325 402.066H141.299L141.275 402.064C133.527 401.667 126.079 401.121 118.72 400.539L111.142 399.929L110.913 399.852C109.617 399.42 108.225 398.313 108.225 396.371C108.225 395.713 108.301 394.925 108.635 394.19C108.977 393.438 109.572 392.791 110.437 392.44C124.207 384.768 138.777 377.885 154.407 372.057C169.958 366.258 185.251 360.194 200.293 354.125L200.298 354.122C204.089 352.605 207.653 350.573 210.991 348.262C214.238 346.014 217.023 343.241 219.626 340.378L219.658 340.342L219.691 340.309C219.691 340.309 219.699 340.301 219.712 340.282C219.724 340.263 219.743 340.231 219.763 340.184C219.805 340.089 219.852 339.938 219.881 339.715C219.939 339.276 219.912 338.633 219.709 337.79C219.2 336.274 218.696 335.123 218.2 334.165C214.236 334.79 210.046 334.96 205.635 334.476C200.417 334.192 196.581 332.559 193.82 329.931L193.555 329.673L193.467 329.586L193.39 329.487C191.339 326.85 190.019 323.988 190.337 320.172L190.337 320.157L190.339 320.14C190.613 317.404 191.173 314.219 192.652 311.26C195.563 305.439 198.425 299.711 200.762 293.738L200.776 293.704L200.791 293.67C203.512 287.409 207.052 281.959 211.402 277.06C212.573 275.584 214.059 274.605 215.804 274.203C217.437 273.826 219.154 273.985 220.867 274.508L221.21 274.618L221.26 274.635C224.112 275.673 226.646 277.008 228.495 278.714L228.855 279.061C234.161 284.367 237.819 290.451 239.815 297.286C239.187 297.355 238.563 297.421 237.943 297.483C237.893 297.489 237.843 297.493 237.794 297.499C235.954 291.404 232.715 285.945 228.076 281.123L227.441 280.475C225.857 278.891 223.481 277.571 220.577 276.515C217.409 275.459 214.769 275.987 212.921 278.363C208.697 283.115 205.266 288.395 202.626 294.467C200.25 300.539 197.345 306.347 194.441 312.155C193.121 314.795 192.594 317.699 192.33 320.339C192.066 323.507 193.121 325.883 194.969 328.259C197.345 330.635 200.778 332.219 205.794 332.483C210.545 333.011 215.034 332.747 219.257 331.955C220.049 333.275 220.841 334.859 221.633 337.235C222.161 339.347 221.897 340.931 221.105 341.723C218.465 344.627 215.561 347.531 212.129 349.907L211.483 350.349C208.235 352.545 204.754 354.494 201.042 355.979C185.994 362.051 170.681 368.123 155.105 373.931L153.648 374.478C138.622 380.168 124.58 386.843 111.281 394.259C110.489 394.523 110.225 395.315 110.225 396.371C110.225 397.163 110.754 397.691 111.546 397.955C121.313 398.747 131.082 399.539 141.378 400.067C151.409 400.331 161.177 399.803 170.945 397.955C180.152 396.164 188.864 392.393 197.56 386.398L198.401 385.811C206.849 379.211 214.769 371.555 221.105 362.579C227.969 353.603 232.721 344.099 235.889 334.067C236.33 332.778 236.73 331.493 237.093 330.213C237.806 330.109 238.528 330.002 239.259 329.891Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_d_39_526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.772 268.125C111.224 265.02 116.055 263.938 121.635 264.489C126.957 264.757 132.004 265.289 136.741 265.815C138.147 265.971 139.505 266.379 140.6 267.175C141.706 267.98 142.46 269.128 142.7 270.545C143.292 272.699 143.273 274.803 142.988 276.797L142.979 276.858L142.967 276.917C140.833 287.322 137.88 296.225 134.07 303.309C130.513 310.149 125.587 316.173 119.826 320.837C113.883 325.698 106.635 330.255 98.1227 334.777L98.1119 334.783C92.4144 337.767 85.9364 340.192 78.9596 342.07L78.9508 342.073L78.942 342.075C72.0031 343.874 64.9391 346.034 58.3824 347.611C51.605 349.699 45.4268 352.024 39.7975 355.094L39.7887 355.1C36.4789 356.882 33.4817 358.886 30.4859 361.881L30.4225 361.945L30.3521 362.004C27.9571 364 26.8781 367.614 27.6148 372.821L38.7027 441.725L38.7086 441.763L38.7135 441.802L38.9049 443.463C39.8142 451.782 40.0024 460.356 39.2486 469.401C38.4502 478.982 37.1145 487.569 34.9547 495.129L31.0484 494.833C29.4725 482.488 27.3713 470.67 24.7457 459.118L24.7437 459.109C22.1025 447.224 19.7193 435.574 17.8629 423.649C15.8629 412.399 14.8032 400.93 14.4596 388.812L14.4 386.38V386.339L14.4127 384.486C14.5373 375.257 15.5879 366.487 17.3424 357.963C19.218 348.584 21.9042 340.247 25.4098 332.697L25.4713 332.566L25.5504 332.445C30.2623 325.238 36.6414 319.979 44.6217 316.402L44.648 316.39L44.6754 316.379C52.4148 313.176 60.9448 310.246 70.7906 307.585L70.8023 307.581L70.8141 307.578L88.3658 303.064C89.938 299.58 91.39 296.49 92.6695 293.779C94.061 290.83 95.2344 288.353 96.1441 286.273C98.0041 282.022 99.6339 278.748 101.032 276.511C102.361 274.385 103.453 272.744 104.296 271.619C105.204 270.409 106.374 269.247 107.772 268.125ZM121.472 266.483C116.192 265.955 111.968 267.011 109.064 269.651C107.744 270.707 106.688 271.763 105.896 272.819L105.587 273.24C104.836 274.279 103.883 275.723 102.728 277.571L102.22 278.413C101.008 280.492 99.5931 283.379 97.9762 287.075L97.235 288.734C95.3942 292.78 92.7946 298.064 89.7916 304.763L71.3121 309.515C61.5441 312.155 53.096 315.059 45.44 318.227C37.7842 321.659 31.7122 326.675 27.2242 333.539C23.7922 340.931 21.1523 349.115 19.3043 358.355C17.4563 367.331 16.4 376.572 16.4 386.339C16.664 399.275 17.7197 411.42 19.8316 423.299C21.6796 435.179 24.0559 446.796 26.6959 458.675C29.3358 470.291 31.4479 482.171 33.0318 494.579C35.0118 487.649 36.2958 479.791 37.1012 471.005L37.2564 469.235C38.0484 459.731 37.7841 450.755 36.7281 442.043L25.6402 373.139C24.8483 367.595 25.9041 363.107 29.0719 360.467C32.0419 357.497 35.0122 355.455 38.1998 353.689L38.8404 353.339C44.2853 350.37 50.194 348.095 56.567 346.083L57.8482 345.683C64.4482 344.099 71.3121 341.987 78.44 340.139C84.875 338.407 90.846 336.21 96.1353 333.549L97.1842 333.011C105.632 328.523 112.76 324.035 118.568 319.283C123.939 314.935 128.566 309.349 131.97 303.004L132.296 302.387C135.992 295.523 138.896 286.811 141.008 276.515C141.272 274.667 141.272 272.819 140.744 270.971C140.496 269.239 139.089 268.202 136.956 267.862L136.52 267.803C131.768 267.275 126.752 266.747 121.472 266.483Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_n_39_526",
    x: 163.4,
    y: 16.699,
    width: 178.697,
    height: 275.88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "2 2",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 108
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_39_526"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_39_526",
    x: 300.769,
    y: 6.29897,
    width: 55.728,
    height: 172.152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_39_526"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_39_526",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_39_526",
    x: 149,
    y: 53.951,
    width: 153.581,
    height: 257.028,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_39_526"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_39_526",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_n_39_526",
    x: 161.4,
    y: 10.4,
    width: 182.735,
    height: 282.729,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "2 2",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 108
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_39_526"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_39_526",
    x: 298.73,
    y: 0.0000247955,
    width: 59.8049,
    height: 184.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_39_526"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_39_526",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_39_526",
    x: 147,
    y: 51.9511,
    width: 157.581,
    height: 259.577,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_39_526"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_39_526",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_n_39_526",
    x: 16.4,
    y: 127.635,
    width: 473.003,
    height: 366.944,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "2 2",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 108
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_39_526"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_39_526",
    x: 233.006,
    y: 185.263,
    width: 99.552,
    height: 101.052,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_39_526"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_39_526",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_39_526",
    x: 95.8252,
    y: 117.235,
    width: 407.977,
    height: 301.295,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_39_526"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_39_526",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_39_526",
    x: 1.99999,
    y: 255.951,
    width: 153.581,
    height: 257.028,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_39_526"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_39_526",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_n_39_526",
    x: 14.4,
    y: 125.636,
    width: 477.003,
    height: 369.492,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "2 2",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 108
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_39_526"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_39_526",
    x: 323.794,
    y: 115.236,
    width: 182.009,
    height: 231.231,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_39_526"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_39_526",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_39_526",
    x: 258.081,
    y: 149.774,
    width: 117.08,
    height: 200.52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_39_526"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_39_526",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_39_526",
    x: 205.83,
    y: 261.182,
    width: 112.51,
    height: 91.5484,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_39_526"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_39_526",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_39_526",
    x: 230.987,
    y: 183.262,
    width: 103.82,
    height: 109.441,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_39_526"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_39_526",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_39_526",
    x: 93.8252,
    y: 263.596,
    width: 160.39,
    height: 156.935,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_39_526"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_39_526",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_39_526",
    x: -0.00000572205,
    y: 253.951,
    width: 157.581,
    height: 259.577,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_39_526"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_39_526",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHerotext);
export default __webpack_public_path__ + "static/media/herotext.b8bfca6633587fdf884ddc6a2908bd35.svg";
export { ForwardRef as ReactComponent };